export const questionsList = [
    {
      questionText: 'question1.value',
      answer: 'question1.answer'
    },
    {
      questionText: 'question2.value',
      answer: 'question2.answer'
    },
    {
      questionText: 'question3.value',
      answer: 'question3.answer'
    },
    {
      questionText: 'question4.value',
      answer: 'question4.answer'
    },
    {
      questionText: 'question5.value',
      answer: 'question5.answer'
    }
];
